class IpaxPreVendaCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-ipax-pre-venda-track]');
    this.slides = [...root.querySelectorAll('[data-ipax-pre-venda-slide]')];
    this.prevBtn = root.querySelector('[data-ipax-pre-venda-prev]');
    this.nextBtn = root.querySelector('[data-ipax-pre-venda-next]');
    this.dotsRoot = root.querySelector('[data-ipax-pre-venda-dots]');
    this.index = 0;
    this.autoplayTimer = null;
    this.touchStartX = 0;

    if (!this.track || this.slides.length === 0) return;

    this.buildDots();
    this.bindEvents();
    this.goTo(0, false);

    if (root.dataset.autoplay === 'true' && this.slides.length > 1) {
      this.startAutoplay();
    }
  }

  bindEvents() {
    this.prevBtn?.addEventListener('click', () => this.step(-1));
    this.nextBtn?.addEventListener('click', () => this.step(1));

    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => {
      if (this.root.dataset.autoplay === 'true') this.startAutoplay();
    });

    this.track.addEventListener('touchstart', (event) => {
      this.touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    this.track.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].screenX - this.touchStartX;
      if (Math.abs(delta) < 40) return;
      this.step(delta < 0 ? 1 : -1);
    }, { passive: true });
  }

  buildDots() {
    if (!this.dotsRoot || this.slides.length <= 1) return;

    this.dotsRoot.innerHTML = '';
    this.slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ipax-pre-venda__dot';
      dot.setAttribute('aria-label', `Ir para pré-venda ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsRoot.appendChild(dot);
    });

    this.dots = [...this.dotsRoot.querySelectorAll('.ipax-pre-venda__dot')];
  }

  step(direction) {
    const next = (this.index + direction + this.slides.length) % this.slides.length;
    this.goTo(next);
    if (this.root.dataset.autoplay === 'true') {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  goTo(index, animate = true) {
    this.index = index;
    this.track.style.transition = animate ? 'transform 0.42s cubic-bezier(0.22, 1, 0.36, 1)' : 'none';
    this.track.style.transform = `translateX(-${index * 100}%)`;

    this.dots?.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    const speed = Number(this.root.dataset.autoplaySpeed) || 6000;
    this.autoplayTimer = window.setInterval(() => this.step(1), speed);
  }

  stopAutoplay() {
    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-ipax-pre-venda]').forEach((root) => {
    new IpaxPreVendaCarousel(root);
  });
});
